import { render, staticRenderFns } from "./Reconocer.vue?vue&type=template&id=a099de9e&scoped=true&"
import script from "./Reconocer.vue?vue&type=script&lang=js&"
export * from "./Reconocer.vue?vue&type=script&lang=js&"
import style0 from "./Reconocer.vue?vue&type=style&index=0&id=a099de9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a099de9e",
  null
  
)

export default component.exports